import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from '@locales'

Vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: 'es',
    fallbackLocale: 'es',
    messages,
    dateTimeFormats: {},
    numberFormats: {}
});

export default i18n